import { ITEMS_REQUESTS_TYPES } from "./itemsRequestsTypes";
import { cleanObject } from "helpers/validateObject";
import { timeStatusItemsRequests } from "helpers/timeStatus";
import { orderArrayV2 } from "helpers/orderArray";

const {
    GET_ITEMS_REQUESTS,
    PATCH_MODIFY,
    FILTER_LIST_REQUESTS,
    SET_CONFIG_FILTERED_ITEMS_REQUESTS,
    SET_CONFIG_PAGE_ITEMS_REQUESTS,
    SET_CONFIG_PAGE_ITEMS_REQUESTS_COUNT,
    SET_CONFIG_SORTED_ITEMS_REQUESTS,
} = ITEMS_REQUESTS_TYPES
const {
    APPROVED,
    IN_ORACLE,
    PARTIALLY_IN_ORACLE,
    REJECTED,
    PENDING
} = timeStatusItemsRequests

const initialState = {
    itemsRequests: [],
    itemUpdate: {},
    config: {
        pageSize: 15,
        page: 0,
        sorted: [],
        filtered: [],
    },
    temp: {
        APPROVED: [],
        IN_ORACLE: [],
        PARTIALLY_IN_ORACLE: [],
        REJECTED: [],
        PENDING: []
    },
    status: {
        APPROVED: true,
        IN_ORACLE: true,
        PARTIALLY_IN_ORACLE: true,
        REJECTED: true,
        PENDING: true,
    },
}

export const splitStatusItemsRequests = (data) => {
    let itemsRequests = {
        [APPROVED.value]: [],
        [IN_ORACLE.value]: [],
        [PARTIALLY_IN_ORACLE.value]: [],
        [REJECTED.value]: [],
        [PENDING.value]: [],
    };

    data.forEach(order => {
        if (itemsRequests.hasOwnProperty(order.status.replace(/ /g, "_"))) {
            itemsRequests[order.status.replace(/ /g, "_")].push(order);
        } else {
            itemsRequests[order.status.replace(/ /g, "_")] = [order];
        }
    });

    return itemsRequests
}

export const itemsRequestsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_ITEMS_REQUESTS:
            const newPayload = payload.map(itemsRequest => cleanObject(itemsRequest))
            const sortNewPayload = orderArrayV2(newPayload, 'createdAt', true)
            const itemsRequests = splitStatusItemsRequests(sortNewPayload)
            return {
                ...state,
                itemsRequests: sortNewPayload,
                temp: itemsRequests,
                status: {
                    ...initialState.status
                },
                config: {
                    ...state.config,
                    page: 0
                }
            }
        case PATCH_MODIFY:
            return {
                ...state,
                itemUpdate: payload
            }
        case FILTER_LIST_REQUESTS:
            let newStatus = { ...state.status }
            newStatus[payload] = !newStatus[payload]
            const in_oracle = newStatus.IN_ORACLE ? state.temp.IN_ORACLE : []
            const delayed = newStatus.PARTIALLY_IN_ORACLE ? state.temp.PARTIALLY_IN_ORACLE : []
            const rejected = newStatus.REJECTED ? state.temp.REJECTED : []
            const pending = newStatus.PENDING ? state.temp.PENDING : []
            const fStatus = [...in_oracle, ...delayed, ...rejected, ...pending]
            return {
                ...state,
                status: newStatus,
                itemsRequests: fStatus,
                config: {
                    ...state.config,
                    page: 0
                }
            }
        case SET_CONFIG_FILTERED_ITEMS_REQUESTS:
            return {
                ...state,
                config: {
                    ...state.config,
                    filtered: payload,
                    page: 0,
                },
            };

        case SET_CONFIG_PAGE_ITEMS_REQUESTS:
            return {
                ...state,
                config: {
                    ...state.config,
                    page: payload,
                },
            };

        case SET_CONFIG_PAGE_ITEMS_REQUESTS_COUNT:
            return {
                ...state,
                config: {
                    ...state.config,
                    pageSize: payload,
                    page: 0,
                },
            };
        case SET_CONFIG_SORTED_ITEMS_REQUESTS:
            return {
                ...state,
                config: {
                    ...state.config,
                    sorted: payload,
                    page: 0,
                },
            };
        default: return state
    }
}